export function scrollStatus(el = document.body) {
  let prevScrollPos = window.pageYOffset;
  el.setAttribute('scroll-status', 'load');

  window.addEventListener('scroll', function() {
    const scrollPos = Math.ceil(window.pageYOffset);
    el.setAttribute('scroll-status', updateScrollStatus(scrollPos, prevScrollPos));
    prevScrollPos = scrollPos;
  });
  
  function updateScrollStatus(current, prev) {
    if (current <= 0) {
      return 'top';
    } else if (current + window.innerHeight >= document.body.scrollHeight) {
      return 'bottom';
    } else if (current > prev) {
      return 'down';
    } else {
      return 'up';
    }
  }  
}
